<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" style="position:relative; top: -60px" v-if="courses.length > 0">
                <v-card>
                    <v-card-text>
                       <v-select v-model="selected_modality" color="#000" item-color="#000" filled :items="modalities" item-value="id" item-text="text" label="Selecciona modalidad"></v-select>
                       <template v-if="filter_courses.length > 0">
                            <v-list dense three-line>
                                <v-list-item-group v-model="selected_course" color="primary">
                                    <template v-for="(course, index) in filter_courses">
                                        <v-list-item :key="index" :value="course">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ course.name }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ course.level.name }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-list-item-action-text>{{ course.schedule[0].start_time }} - {{ course.schedule[0].end_time }}</v-list-item-action-text>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider v-if="index < filter_courses.length-1"></v-divider>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                       </template>
                       <v-card v-else outlined>
                           <v-card-text>
                               <p class="mb-0 text-center">
                                    Sin cursos asignados en esta modalidad
                               </p>
                           </v-card-text>
                       </v-card>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" lg="9" style="position:relative; top: -60px" v-if="courses.length > 0">
                <template v-if="selected_course">
                    <v-card>
                        <v-card-title>
                            <v-chip class="mr-2" color="primary">
                                <span class="d-none d-sm-flex" small>
                                    {{ selected_course.level.name }}
                                </span>
                            </v-chip>
                            {{ selected_course.name }}
                            <v-spacer></v-spacer>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="success" v-bind="attrs" v-on="on" fab small @click="lesson_link_dialog = true">
                                        <v-icon>mdi-link</v-icon>
                                    </v-btn>
                                </template>
                                <span>Enlace de clase</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="error" class="mx-2" v-bind="attrs" v-on="on" fab small @click="recording_dialog = !recording_dialog">
                                        <v-icon>mdi-video</v-icon>
                                    </v-btn>
                                </template>
                                <span>Grabaciones</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" fab small v-bind="attrs" v-on="on" @click="materials_dialog = !materials_dialog">
                                        <v-icon>mdi-file-word</v-icon>
                                    </v-btn>
                                </template>
                                <span>Documentos</span>
                            </v-tooltip>
                        </v-card-title>
                        <v-card-subtitle class="pb-0 pt-3">{{ selected_course.modality.name }}</v-card-subtitle>
                        <v-card-subtitle class="pb-0 pt-3">Fecha de inicio : <strong>{{ selected_course.start_date }}</strong></v-card-subtitle>
                        <v-card-text>
                            <v-card outlined>
                                <v-card-subtitle>Horario</v-card-subtitle>
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Día</th>
                                                    <th>Inicio</th>
                                                    <th>Termino</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(schedule, index) in selected_course.schedule" :key="index">
                                                    <td>{{ schedule.day }}</td>
                                                    <td>{{ schedule.start_time }}</td>
                                                    <td>{{ schedule.end_time }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>

                            <v-card class="mt-3" outlined>
                                <v-card-subtitle>Alumnos</v-card-subtitle>
                                <v-card-text>
                                    <v-data-table 
                                    :items="selected_course.students"
                                    :search="search"
                                    :headers="headers"
                                    disable-pagination
                                    :no-data-text="no_data_text"
                                    :loading-text="loading_text"
                                    hide-default-footer>
                                        <template v-slot:top>
                                            <v-text-field
                                                v-model="search"
                                                clearable
                                                dense
                                                outlined
                                                hide-details
                                                label="Buscar"
                                                append-icon="mdi-magnify"
                                                color="#818181"
                                            ></v-text-field>
                                        </template>
                                        <template v-slot:item.status="{ item }">
                                            <v-chip :color="item.verified ? 'success' : 'error'">
                                                <span>{{ item.verified ? 'Verificado' : 'Pendiente' }}</span>
                                            </v-chip>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </template>
                <v-card v-else>
                    <v-card-title>
                        Curso asignado
                    </v-card-title>
                    <v-card-text>
                        <v-card outlined>
                            <v-card-text>
                                <h3 class="text-center">
                                    Seleccione un curso
                                </h3>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col v-else cols="12" lg="6" style="position:relative; top: -60px">
                <v-card>
                    <v-card-title>Mis cursos</v-card-title>
                    <v-card-text>
                        <div class="text-center">
                            <h2 class="mb-3" >Aún no se ha asignado ningún curso</h2>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="lesson_link_dialog" max-width="800" persistent>
            <v-card v-if="selected_course">
                <v-card-title>Enlace de la clase</v-card-title>
                <v-form ref="lesson_link_form" @submit.prevent="lesson_link_store">
                    <v-card-text class="text-center">
                        <v-alert text type="success" v-if="selected_course.lesson && selected_course.lesson.length > 0">Enlace ingresado anteriormente : <strong>{{ selected_course.lesson[0].meet_url }}</strong></v-alert>
                        <v-text-field @keydown.space.prevent v-model="lesson_link" filled placeholder="Solo la URL" :rules="[rules.required, rules.url]"></v-text-field>
                        <small>Recuerda enviar el enlace 5 minutos antes de la hora de inicio</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="lesson_link_dialog = false">Cerrar</v-btn>
                        <v-btn color="#008dd4" type="submit" dark>
                            {{ selected_course.lesson && selected_course.lesson.length > 0 ? 'Actualizar' : 'Aceptar' }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <recordings :dialog="recording_dialog" :course="selected_course" :store_url="store_recording_url" :delete_url="delete_recording_url"></recordings>
        <materials :dialog="materials_dialog" :course="selected_course" :store_url="store_material_url" :delete_url="delete_material_url"></materials>

     </v-container>
</template>
<script>

import recordings from './recordings'
import materials from './materials'
import iziToast from 'izitoast'

export default {
    props:['courses'],
    components:{
        recordings,
        materials
    },

    data: () => ({
        //urls
        store_recording_url:"/recordings/store",
        delete_recording_url:"/recordings/delete",
        store_material_url:"/class-materials/store",
        delete_material_url:"/class-materials/delete",

        //dialogs
        recording_dialog:false,
        materials_dialog:false,
        lesson_link_dialog:false,

        //model
        items:"",
        item_course:"",
        selected_modality:"",
        selected_course:"",

        //lesson
        lesson_link:"",

        //Rules
        rules:{
            required: v => !!v || 'El campo es requerido',
            url: v => /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(v) || 'El enlace ingresado no es válido',
        },

        //modalities
        modalities:[
            { id:1, text:'Lunes, Miércoles y Viernes' },
            { id:2, text:'Martes y Jueves' },
            { id:3, text:'Sabatino' },
            { id:4, text:'Infantil Escolarizado Menor' },
            { id:5, text:'Infantil Escolarizado Mayor' },
        ],

        //data table props
        color:"#818181",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'Nombre', value:'user.fullname' },
            { text:'Estatus', value:'status' },
        ],
    }),

    computed:{
        filter_courses:function(){
            let filter_courses = []

            if(this.selected_modality === ""){
                filter_courses = this.items
            }else{
                for(let item of this.items){
                    if(item.modality_id == this.selected_modality){
                        filter_courses.push(item)
                    }
                }
            }

            return filter_courses
        }
    },

    mounted(){
        this.items = this.courses
    },

    methods:{
        getItems:function(){
            axios.get("/assigned-courses", { params:{ ajax:true }}).then(response => {
                this.items = response.data.courses
            }).catch(error => {})
        },

        lesson_link_store:function()
        {
            if(this.$refs.lesson_link_form.validate()){
                let data = {}

                data.course_id = this.selected_course.id
                data.meet_url  = this.lesson_link

                axios.post('/lessons/store', data).then(response => {
                    this.lesson_link_dialog = false
                    this.lesson_link = ""

                    this.getItems()

                    iziToast.success({
                        title:"Correcto",
                        position:"topRight",
                        message:"Enlace registrado correctamente"
                    })

                }).catch(error => {
                    izitoast.error({
                        title:"Error",
                        message:"Ha ocurrido un error en la comunicación con el servidor",
                        position:"topRight"
                    })
                })

                this.getItems()
                
            }
        }
    }
}
</script>
